
document.addEventListener("DOMContentLoaded", () => {
  const faqItems = document.querySelectorAll(".faqrs-item");

  faqItems.forEach(item => {
    const question = item.querySelector(".faqrs-question");
    const answer = item.querySelector(".faqrs-answer");

    question.addEventListener("click", () => {
      const isActive = item.classList.contains("faqrs-active");

      // Close all items
      faqItems.forEach(i => {
        i.classList.remove("faqrs-active");
        i.querySelector(".faqrs-answer").style.maxHeight = null;
        i.querySelector(".faqrs-question").setAttribute("aria-expanded", "false");
      });

      // Open clicked item
      if (!isActive) {
        item.classList.add("faqrs-active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        question.setAttribute("aria-expanded", "true");
      }
    });
  });
});

